import './next-steps.scss'

import { Image } from 'react-bootstrap'
import { ActivationIcon, CertificateIcon, EuroIcon, MailIcon } from 'src/assets'
import { CallbackDates } from 'src/types'
import { fillTemplate } from 'src/utils'

import { useNextSteps } from './next-steps.hook'

export const NextSteps = ({
  isPisPayment,
  callbackDates,
}: {
  isPisPayment: boolean
  callbackDates?: CallbackDates
}) => {
  const { t, fills } = useNextSteps({ callbackDates })

  return (
    <>
      <div className="bg-ffffff p-3 p-md-5">
        <h2 className="font-48-light">{t('thank_you.next_steps.title')}</h2>
        <div className="d-md-flex justify-content-between">
          {isPisPayment && (
            <div className="col-md-3 pe-5">
              <div style={{ height: '5rem' }} className="mb-3">
                <Image src={EuroIcon} width={34} className="filter-7c2d35 mt-5 mb-4" />
              </div>
              <h5>{t('thank_you.next_steps.c1_pis.title')}</h5>
              <p className="c-7f7f7f t-justify">{t('thank_you.next_steps.c1_pis.description')}</p>
            </div>
          )}
          <div className={`${isPisPayment ? 'col-md-3' : 'col-md-4'} pe-5`}>
            <div style={{ height: '5rem' }} className="mb-3">
              <Image src={MailIcon} width={38} className="filter-7c2d35 mt-5 mb-4" />
            </div>
            <h5>{t('thank_you.next_steps.c1.title')}</h5>
            <p className="c-7f7f7f t-justify">{t('thank_you.next_steps.c1.description')}</p>
          </div>
          <div className={`${isPisPayment ? 'col-md-3' : 'col-md-4'} pe-5`}>
            <div style={{ height: '5rem' }} className="mb-3">
              <Image src={ActivationIcon} width={30} className="filter-7c2d35 mt-5 mb-4" />
            </div>
            <h5>{t('thank_you.next_steps.c2.title')}</h5>
            <p className="c-7f7f7f t-justify">
              {fillTemplate(t('thank_you.next_steps.c2.description'), fills)}
            </p>
          </div>
          <div className={`${isPisPayment ? 'col-md-3' : 'col-md-4'} pe-5`}>
            <div style={{ height: '5rem' }} className="mb-3">
              <Image src={CertificateIcon} width={30} className="filter-7c2d35 mt-5 mb-4" />
            </div>
            <h5>{t('thank_you.next_steps.c3.title')}</h5>
            <p className="c-7f7f7f t-justify">{t('thank_you.next_steps.c3.description')}</p>
          </div>
        </div>
      </div>
    </>
  )
}
